import { render } from "./LanguageWatermark.vue?vue&type=template&id=eb1d0758&scoped=true"
import script from "./LanguageWatermark.vue?vue&type=script&lang=js"
export * from "./LanguageWatermark.vue?vue&type=script&lang=js"

import "./LanguageWatermark.vue?vue&type=style&index=0&id=eb1d0758&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb1d0758"]])

export default __exports__